import { render, staticRenderFns } from "./PromotionTicketListTable.vue?vue&type=template&id=65e47ab2&scoped=true"
import script from "./PromotionTicketListTable.vue?vue&type=script&lang=js"
export * from "./PromotionTicketListTable.vue?vue&type=script&lang=js"
import style0 from "./PromotionTicketListTable.vue?vue&type=style&index=0&id=65e47ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e47ab2",
  null
  
)

export default component.exports